import { Member } from "./Member.model";
import { ReportResponse } from "./ReportResponse.model";

export class Answer {
  public id: number = -1;
  public question_id: number = -1;
  public content: string = '';

}